<template>
  <SoPageWithHeader title="Deposit Requests">
    <AdminCreditCheckListTable />
  </SoPageWithHeader>
</template>

<script lang="ts">
  import SoPageWithHeader from "@/components/templates/SoPageWithHeader.vue"
  import AdminCreditCheckListTable from "@/views/operations/creditChecks/components/OpsCreditChecksListTable.vue"
  import { defineComponent } from "vue"

  export default defineComponent({
    components: {
      AdminCreditCheckListTable,
      SoPageWithHeader,
    },
  })
</script>
